export const paths = {
  index: "/",
  match_invoice: "/match-invoice",
  report: "/report/1",
};
